export default __webpack_public_path__ + "static/media/execute_exitPractise.48e56ef0.png";